import { render, staticRenderFns } from "./product-swiper.vue?vue&type=template&id=7921bbe8&scoped=true&"
import script from "./product-swiper.vue?vue&type=script&lang=js&"
export * from "./product-swiper.vue?vue&type=script&lang=js&"
import style0 from "./product-swiper.vue?vue&type=style&index=0&id=7921bbe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921bbe8",
  null
  
)

export default component.exports